
	import Vue from 'vue';
	import Component from 'vue-class-component';

	/** ExpansionCard is a wrapper component for VExpansionPanel */
	@Component
	export default class ExpansionCard extends Vue {}
